module.exports = __webpack_public_path__ + "img/onda1.42d7b38a.png";